import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { projectsData } from '../data/projectsData';
import { FaInstagram } from 'react-icons/fa';
import './Portfolio.css';

const Portfolio = () => {
  const portfolioRef = useRef(null);
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [activeCategory, setActiveCategory] = useState('todos');
  const [projectsPerPage] = useState(18);

  // eslint-disable-next-line
  const categories = [
    { id: 'todos', name: 'Todos' },
    { id: 'residencial', name: 'Residencial' },
    { id: 'apartamento', name: 'Apartamento' },
    { id: 'comercial', name: 'Comercial' },
    { id: 'interiores', name: 'Interiores' },
    { id: 'outros', name: 'Outros' }
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = portfolioRef.current?.querySelectorAll('.fade-in, .slide-in-up');
    elements?.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  const filteredProjects = activeCategory === 'todos' 
    ? projectsData 
    : projectsData.filter(project => project.category === activeCategory);

  const indexOfLastProject = currentPage * projectsPerPage;
  const indexOfFirstProject = indexOfLastProject - projectsPerPage;
  const currentProjects = filteredProjects.slice(indexOfFirstProject, indexOfLastProject);
  const totalPages = Math.ceil(filteredProjects.length / projectsPerPage);

  const handleViewDetails = (projectId) => {
    navigate(`/projeto/${projectId}`);
  };

  const getOptimizedImageUrl = (baseUrl, width = 400, height = 400) => {
    if (baseUrl.includes('res.cloudinary.com') && baseUrl.includes('/upload/')) {
      return baseUrl.replace('/upload/', `/upload/w_${width},h_${height},c_fill,q_auto,f_auto/`);
    }
    return baseUrl;
  };

  // eslint-disable-next-line
  const handleCategoryChange = (categoryId) => {
    setActiveCategory(categoryId);
    setCurrentPage(1);
  };

  const goToPage = (pageNumber) => {
    setCurrentPage(pageNumber);
    portfolioRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  // eslint-disable-next-line
  const goToNextPage = () => {
    if (currentPage < totalPages) {
      goToPage(currentPage + 1);
    }
  };

  // eslint-disable-next-line
  const goToPrevPage = () => {
    if (currentPage > 1) {
      goToPage(currentPage - 1);
    }
  };

  return (
    <section id="portfolio" className="portfolio section" ref={portfolioRef}>
      <div className="container">
        <div className="section-header fade-in">
          <h2>Nosso Portfólio</h2>
          <p>Conheça nossos projetos por dentro e por fora!</p>
        </div>

        <div className="button-instagram fade-in">
          <a href="https://www.instagram.com/arq.biancapaulino/" className="btn btn-instagram">
            <FaInstagram className="whatsapp-icon" />
            Confira nosso portfólio completo
          </a>
        </div>


        {/* Filtros por Categoria */}
        {/* <div className="portfolio-filters fade-in">
          {categories.map((category) => (
            <button
              key={category.id}
              className={`filter-btn ${activeCategory === category.id ? 'active' : ''}`}
              onClick={() => handleCategoryChange(category.id)}
            >
              {category.name}
            </button>
          ))}
        </div> */}

        {/* Grid de Projetos */}
        <div className="portfolio-grid">
          {currentProjects.map((project, index) => (
            <div 
              key={project.id} 
              className="portfolio-item slide-in-up"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="portfolio-image">
                <img 
                  src={getOptimizedImageUrl(project.mainImage)}
                  alt={project.title}
                  className="project-image"
                  loading="lazy"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.nextElementSibling.style.display = 'flex';
                  }}
                />
                <div className="image-placeholder" style={{ display: 'none' }}>
                  <span>Imagem do Projeto</span>
                </div>
                
                <div className="portfolio-overlay">
                  <div className="portfolio-content">
                    <h3 className="project-title">{project.title}</h3>
                    <button 
                      className="btn btn-primary"
                      onClick={() => handleViewDetails(project.id)}
                    >
                      Ver Detalhes
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Paginação */}
        {/* {totalPages > 1 && (
          <div className="portfolio-pagination fade-in">
            <button 
              className="pagination-btn prev"
              onClick={goToPrevPage}
              disabled={currentPage === 1}
            >
              ← Anterior
            </button>
            
            <div className="pagination-numbers">
              {[...Array(totalPages)].map((_, index) => (
                <button
                  key={index + 1}
                  className={`pagination-number ${currentPage === index + 1 ? 'active' : ''}`}
                  onClick={() => goToPage(index + 1)}
                >
                  {index + 1}
                </button>
              ))}
            </div>
            
            <button 
              className="pagination-btn next"
              onClick={goToNextPage}
              disabled={currentPage === totalPages}
            >
              Próximo →
            </button>
          </div>
        )}

        {filteredProjects.length === 0 && (
          <div className="portfolio-empty fade-in">
            <p>Nenhum projeto encontrado nesta categoria.</p>
          </div>
        )} */}

        {/* <div className="portfolio-stats fade-in">
          <p>
            {filteredProjects.length > 0 && (
              <>Exibindo {indexOfFirstProject + 1}-{Math.min(indexOfLastProject, filteredProjects.length)} de {filteredProjects.length} projetos</>
            )}
            {activeCategory !== 'todos' && ` em ${categories.find(c => c.id === activeCategory)?.name}`}
          </p>
        </div> */}
      </div>
    </section>
  );
};

export default Portfolio;